import {
    Autocomplete,
    CircularProgress,
    Popper,
    TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";

function AsyncSelect({
    options,
    onChangeSearch,
    onChangeSelect,
    disabled = false,
    label = "Seleccione una opción",
    onClose = () => {},
    defaultValue = "",
    renderOption = null,
    optionLabel = null,
}) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null); // Estado para el valor seleccionado

    const optionLabelDefault = (option) => option.name;

    const renderOptionDefault = (props, option) => (
        <li {...props} key={option.id}>
            {option.name}
        </li>
    );

    useEffect(() => {
        if (search !== null) {
            setLoading(true);
            const timer = setTimeout(() => {
                onChangeSearch(search);
                setLoading(false);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [search]);

    useEffect(() => {
        setSelectedValue(defaultValue || null);
    }, [defaultValue]);

    const handleClose = () => {
        setOpen(false);
        onClose();
        setSearch(null); // Limpiar la búsqueda
    };
    return (
        <Autocomplete
            PopperComponent={(props) => <Popper {...props} placement="bottom-end" />}
            disabled={disabled}
            open={open}
            value={selectedValue} // Controlar el valor
            onChange={(e, value) => {
                setSelectedValue(value);
                onChangeSelect(value);
            }}
            onOpen={() => setOpen(true)}
            onClose={handleClose}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            getOptionLabel={optionLabel || optionLabelDefault}
            renderOption={renderOption || renderOptionDefault}
            noOptionsText="Sin opciones"
            loadingText="Cargando..."
            options={options}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Comience a escribir para realizar la búsqueda"
                    label={label}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}

export default AsyncSelect;
